import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class MemphisLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Memphis, TN" />
        <LocationMicroNav />

        <LocationContent 
          category="PlacesForBikes" 
          title="Big Jump in Bluff City"
          story="The Big Jump's focus area in South Memphis is a low-income neighborhood with a majority African-American population. It exhibits all of the typical signs of generational poverty and lack of investment in infrastructure. Core services are lacking: grocery stores, doctors, community centers, etc. A highly motivated community is working to change the neighborhood’s trajectory. Biking has increased during the last seven years, partly a result of infrastructure and the creation of destinations that people need and want to travel to."
        />  
        <Img
          title="MemphisTN"
          alt="Memphis breaking the cycle of poverty"
          sizes= { this.props.data.memphisOneTwoImage.sizes }
        />   

        <LocationRelated 
          prevLocationName="Texas"
          prevLocationPath="texas"
          prevLocationImgPath= { this.props.data.memphisPrevImage }
          nextLocationName="Iowa"
          nextLocationPath="iowa"
          nextLocationImgPath= { this.props.data.memphisNextImage }
        /> 
      </div>
    )
  }
}

export default MemphisLocation

// GraphQL query
export const MemphisImageQuery = graphql`
  query MemphisImageQuery {
    memphisOneTwoImage: imageSharp(id: { regex: "/PFB_Memphis_1-2/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    memphisPrevImage: imageSharp(id: { regex: "/PFB_TEXAS/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    memphisNextImage: imageSharp(id: { regex: "/PFB_IOWA/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/memphis.js